<form [formGroup]="formUpdate" class="fb-dialog" (ngSubmit)="openDialog()">

  <h2 class="fb-dialog__title">{{ 'PROCEDIMIENTOS.FORM.UPDATE_CONTENTS' | translate }}</h2>

  <div class="fb-card">
    <div class="fb-card__header">{{ 'PROCEDIMIENTOS.FORM.DATA' | translate }}</div>
    <div class="fb-card__body">

      <div class="fb-col fb-col--12">
        <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.NAME' | translate }}</label>
        <input
          type="text"
          class="fb-input"
          formControlName="nombre"
          name="nombre"
          placeholder="{{ procedimiento.nombre }}">
      </div>

      <div class="fb-col fb-col--12">
        <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.TYPE' | translate }}</label>
        <input
          type="text"
          class="fb-input"
          [value]="procedimiento.custom ? ('PROCEDIMIENTOS.FORM.TYPE_DYN' | translate) : ('PROCEDIMIENTOS.FORM.TYPE_STD' | translate)"
          readonly>
      </div>

    </div>
  </div>

  <div class="fb-card">
    <div class="fb-card__header">{{ 'PROCEDIMIENTOS.FORM.VALIDITY' | translate }}</div>
    <div class="fb-card__body">

      <!-- Fecha activo -->
      <div class="fb-col fb-col--12">
        <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.DATE_ACTIVE' | translate }}</label>

        <div class="fb-datetime">
          <input type="date" class="fb-input" formControlName="fechaApertura">
          <input type="time" class="fb-input fb-input--time" formControlName="horaApertura">
        </div>

        <div *ngIf="fechaAperturaIncompletaWarning" class="fb-alert">
          <p>{{ 'PROCEDIMIENTOS.FORM.DATE_INCOMPLETE' | translate }}</p>
        </div>
      </div>

      <!-- Fecha inactivo -->
      <div class="fb-col fb-col--12">
        <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.DATE_INACTIVE' | translate }}</label>

        <div class="fb-datetime">
          <input type="date" class="fb-input" formControlName="fechaCierre">
          <input type="time" class="fb-input fb-input--time" formControlName="horaCierre">
        </div>

        <div *ngIf="fechaCierreIncompletaWarning" class="fb-alert">
          <p>{{ 'PROCEDIMIENTOS.FORM.DATE_INCOMPLETE' | translate }}</p>
        </div>
      </div>

      <!-- Activo -->
      <label class="fb-toggle">
        <input
          type="checkbox"
          [checked]="isVisible"
          (change)="updateVisibility($any($event.target))">
        <span class="fb-toggle__track">
          <span class="fb-toggle__thumb"></span>
        </span>
        <span class="fb-toggle__text">{{ 'COMMON.ACTIVE' | translate }}</span>
      </label>

    </div>
  </div>

  <div class="fb-dialog__actions">
    <button type="button" class="fb-btn fb-btn--ghost" (click)="onNoClick()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="submit" class="fb-btn fb-btn--primary">{{ 'COMMON.SAVE' | translate }}</button>
  </div>

</form>
